import { Column } from "@/components/Datatable/types";
import { MonthlyReportRow } from "../api/fetchMonthlyReport";

/**
 * Ordered column definitions for the monthly report, matching the columns
 * produced by the backend query. Used for both the on-screen table and the
 * CSV export so the two never drift.
 *
 * Note: `city_state` is intentionally NOT listed here. It is deliberately
 * excluded from the table and the CSV to preserve parity with the labs source
 * report; the field is surfaced only on the Trade Leaderboard cards (member
 * subtitle). This omission is by design — please don't add it back.
 */
export const MONTHLY_REPORT_FIELDS: {
  key: keyof MonthlyReportRow;
  header: string;
}[] = [
  { key: "month", header: "Month" },
  { key: "trade", header: "Trade" },
  { key: "category", header: "Category" },
  { key: "company", header: "Company" },
  { key: "full_name", header: "Full Name" },
  { key: "numerator", header: "Numerator" },
  { key: "denominator", header: "Denominator" },
  { key: "calculated", header: "Calculated" },
  { key: "numerator_label", header: "Numerator Label" },
  { key: "denominator_label", header: "Denominator Label" },
  { key: "calculated_label", header: "Calculated Label" },
  { key: "primary_metric", header: "Primary Metric" },
  { key: "tier", header: "Tier" },
];

export const NUMERIC_MONTHLY_REPORT_FIELDS = new Set<keyof MonthlyReportRow>([
  "numerator",
  "denominator",
  "calculated",
  "tier",
]);

export const monthlyReportColumns: Column<MonthlyReportRow>[] =
  MONTHLY_REPORT_FIELDS.map(({ key, header }) => ({
    id: key,
    accessorKey: key,
    header,
    enableSorting: true,
  }));
